import Vue from 'vue'
import Vuex from 'vuex'

import { user } from './user'
import { fanzones } from './fanzones'
import { artists } from './artists'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user: user,
    fanzones: fanzones,
    artists: artists,
  }
})
